import styled from 'styled-components';
import { ThemeInterface } from '../../interfaces/themeInterface';

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 48px;
  cursor: default;
  width: 100%;
  min-height: 10vh;
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
  background-color: ${({ theme }: { theme: ThemeInterface }) => theme.background};

  @media (max-width: 920px) {
    display: none;
  }
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
